// Generated from SVG to Code Figma Plugin

export const AgentLineScript = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4 4.25C4 3.00736 5.00736 2 6.25 2H14.068C14.6648 2 15.2371 2.23705 15.659 2.65901L19.341 6.34099C19.7629 6.76295 20 7.33524 20 7.93198V19.75C20 20.9926 18.9926 22 17.75 22H6.25C5.00736 22 4 20.9926 4 19.75V4.25Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M15 3V5.5C15 6.32843 15.6716 7 16.5 7H19"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
